import * as styles from './EmailCreationFormInlineContent.module.css'

function EmailCreationFormInlineContent({
  children,
  className = styles.EmailCreationFormInlineContent,
}) {
  return <div className={className}>{children}</div>
}

export default EmailCreationFormInlineContent
